import { render, staticRenderFns } from "./TdModifyOrg.vue?vue&type=template&id=1df09849&scoped=true&"
import script from "./TdModifyOrg.vue?vue&type=script&lang=js&"
export * from "./TdModifyOrg.vue?vue&type=script&lang=js&"
import style0 from "./TdModifyOrg.vue?vue&type=style&index=0&id=1df09849&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df09849",
  null
  
)

export default component.exports